import React from 'react';
import './machine&deep-learning.css';

const m_attend = () => {
    return (
        <div className="m_attend__wrap">
            <div className="m_learning container">
                <h3 className="m_learning--title">Why Attend?</h3>
                <p className="m_learning--text inner_pages--text">Immerse yourself in talks, tutorials, and workshops on Machine Learning and Deep Learning tools, topics, models and advanced trends.</p>
                <p className="m_learning--text inner_pages--text">Expand your network and connect with like-minded attendees to discover how Machine Learning and Deep Learning knowledge can transform not only your data models but also your business and career.</p>
                <p className="m_learning--text inner_pages--text">Meet and connect with the core contributors and top practitioners in the expanding and exciting fields of Machine Learning and Deep Learning.</p>
                <p className="m_learning--text inner_pages--text">Learn how the rapid rise of intelligent machines is revolutionizing how we make sense of data in the real world and impacting the domains of business, society, healthcare, finance, manufacturing, and more.</p>
            </div>
        </div>
    );
};

export default m_attend;